import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {loadMeAction} from '../../reducers/user';
import {loadCountsForSidenavAction} from '../../reducers/analytics';

import {useFormData} from '../../hook';

import {initDatas} from './common';

import UIKit from '../../Components/UIKit';
import OrderReturnTableStyle from '../../Components/Widget/Order/ReturnTableStyle';
import SearchHead from '../../Components/Widget/SearchHead';
import SearchModal from '../../Components/Widget/SearchModal';
import SearchForm from '../../Components/Widget/SearchForm';

const ReturnList = () => {
  const dispatch = useDispatch();
  const {loadMeLoading, me, loadMeDone, loadMeError} = useSelector(state => state.user);

  const searchForm = useFormData({
    dateSelect: 'all',
    dateRadio: '',
    startDate: '',
    endDate: '',
    searchType: 'all',
    searchValue: '',
    status: 'all',
  });

  useEffect(() => {
    dispatch(loadMeAction());
    dispatch(loadCountsForSidenavAction());
  }, []);

  return loadMeLoading
    ? null
    : loadMeDone && (
        <div>
          <div>
            <SearchHead modalId={'naverPayCancelListSearchModal'} />
            <SearchModal modalId={'naverPayCancelListSearchModal'} searchForm={searchForm}>
              <SearchForm searchForm={searchForm} useSearchComponents={initDatas.useSearchComponents} />
            </SearchModal>
          </div>
          <div className="uk-margin-medium-top">
            <OrderReturnTableStyle payType={1} />
          </div>
        </div>
      );
};

export default ReturnList;
